import React, { useState } from 'react';
import { EditRegular, DeleteRegular } from '@fluentui/react-icons';
import { Image as FluentImage } from '@bingads-webui-react/fabric-control';
import { Button, tokens } from '@fluentui/react-components';
import { useStyles } from './style';
import { IList } from './type';

export const ListItem = React.memo(({
  onEdit, onRemove, imageData, index, showEditBtn, i18n,
}: IList) => {
  const classes = useStyles();
  const [showActionBtn, setShowActionBtn] = useState(false);
  const onMouseEnter = () => {
    setShowActionBtn(true);
  };
  const onMouseLeave = () => {
    setShowActionBtn(false);
  };
  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Tab') {
      onMouseEnter();
    }
  };
  return (
    <li key={index} className="list-image" aria-label={i18n.getString(_TL_('assets lists'))}>
      <div
        role="button"
        tabIndex={0}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onKeyDown={onKeyDown}
      >
        <FluentImage src={imageData.ThumbnailUrl} alt="brand-kit" />
        {showActionBtn && (
        <div className={classes.actionBtns}>
          {showEditBtn && (
          <Button
            icon={<EditRegular color={tokens.colorNeutralForeground1} />}
            data-idx={index}
            size="medium"
            aria-label={i18n.getString(_TL_('Edit Button'))}
            className="edit_btn"
            onClick={onEdit}
          />
              )}
          <Button
            icon={<DeleteRegular color={tokens.colorNeutralForeground1} />}
            data-idx={index}
            size="medium"
            aria-label={i18n.getString(_TL_('Delete Button'))}
            className="del_btn"
            onClick={onRemove}
          />
        </div>
          )}
      </div>
    </li>
  );
});
